import React, { useContext } from 'react';
import { CanvasContainer } from './CanvasContainer';
import { OptionsContainer } from './OptionsContainer';
import { ConstructorBlock } from './Constructor.styles';
import classNames from "classnames";
import styles from "./Header/header.module.css";
import { Popover } from "@mui/material";
import { bindPopover } from "material-ui-popup-state";
import { usePopupState } from "material-ui-popup-state/hooks";
import { canvasModeContext } from "../context/canvasModeContext";

interface IConstructorProps {
    mode: string;
    isSeamless: boolean;
    isSigned: boolean;
}

export function Constructor(props: IConstructorProps) {
    const { mode, isSeamless, isSigned } = props;
    const popupState = usePopupState({
        variant: 'popover',
        popupId: `popover-user-message`,
    });
    const { fullscreen } = useContext(canvasModeContext);

    return (
        <div className={classNames(styles.mainContainer)}>
            {!fullscreen ? (
                <ConstructorBlock>
                    <CanvasContainer mode={mode} isSeamless={isSeamless} isSigned={isSigned}/>
                    <OptionsContainer mode={mode}/>
                </ConstructorBlock>
            ) : (
                <div>
                    <CanvasContainer mode={mode} isSeamless={isSeamless} isSigned={isSigned}/>
                    <div className={styles.hidden}>
                        <OptionsContainer mode={mode}/>
                    </div>
                </div>
            )}
            <Popover
                className={classNames(styles.popover)}
                {...bindPopover(popupState)}
            >
                <div></div>
            </Popover>
        </div>
    );
}
